import { toPng } from "html-to-image";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import * as service from "../services/employeeApi";
import { setIsLoading, setSubOrdinatesList, setSupervisorDetails } from "../slices/employeeSlice";

function useEmployeeEmploymentSubordinates() {
  const dispatch = useDispatch();
  const { id } = useParams()
  const { currentCompany, currentEmployee } = useSelector((state) => state.company);
  const isLoading = useSelector((state) => state.employee.isLoading);

  const getSubOrdinates = useCallback(
    async () => {
      try {
        dispatch(setIsLoading(true));
        const response = await service.getSubOrdinates({
          companyId: currentCompany,
          employeeId: id,
        });
        dispatch(setSubOrdinatesList(response?.data?.subOrdinateDetailsList || []));
        dispatch(setSupervisorDetails(response?.data?.supervisorDetails || {}));
      } catch (error) {
        console.log(error);
      } finally {
        dispatch(setIsLoading(false));
      }
    },
    [currentCompany, id, dispatch]
  );

  useEffect(() => {
    getSubOrdinates();
  }, [getSubOrdinates]);


  const onDownload = () => {
    const chartElement = document.getElementById('employmentSubordinates');

    var originalWidth = chartElement.style.width;
    var originalHeight = chartElement.style.height;
    chartElement.style.width = chartElement.scrollWidth + 'px';
    chartElement.style.height = chartElement.scrollHeight + 'px';

    toPng(chartElement)
      .then((dataUrl) => {
        chartElement.style.width = originalWidth;
        chartElement.style.height = originalHeight;
        const link = document.createElement('a');
        link.href = dataUrl;
        link.download = 'employmentSubordinates.png';
        link.click();
      })
      .catch((error) => {
        console.error('Could not generate image', error);
      });
  };


  return {
    isLoading,
    onDownload
  }

}

export default useEmployeeEmploymentSubordinates;
